<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <div class="mx-auto center pt-8">
        <h1 class="bold">O simulado foi enviado!</h1>
        <p v-if="mock == 13">
          Caso você vá prestar o exame para os módulos 3, 4, 5 e/ou 6, retorne
          às <b>15 horas</b>
        </p>
        <p>Os resultados serão processados e enviados por <b>e-mail.</b></p>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      dialog: true,
      mock: null,
    };
  },
  mounted() {
    this.mock = this.$route.query.p;
  },
};
</script>
